import moment from "moment";

class Time {
  static day = (date) => moment(date).format("DD");

  static month = (date) => moment(date).format("MMMM");

  static year = (date) => moment(date).format("YYYY");

  static dateWrittenOut = (date) => {
    return `${Time.month(date)} ${Time.day(date)}, ${Time.year(date)}`;
  };

  static unixTimestampToIsoString = (timestamp) =>
    moment.unix(timestamp).toISOString();

  static secondsSinceEpoch = () => Math.floor(moment().unix() / 1000);

  static millisecondsSinceEpoch = () => moment().unix()

  static currentTimeAsISOString = () => moment().toISOString();

  static oneWeekFromNow = () => moment().add(7, "days");

  static oneMonthFromNow = () => moment().add(1, "month");

  static oneYearFromNow = () => moment().add(1, "year");
}

export default Time;
